import { FormattedMessage } from 'react-intl';
import messages from '../../Forms/Forms.messages';
import { addFieldValidators } from '../addressValidation';

const fields = addFieldValidators([
  {
    id: 'address_id',
    element: 'input',
    type: 'hidden',
    // Removed since it was breaking react-intl context on modal forms
    // TODO: Is this required for the hidden input?
    // maxLength: 128,
    // isRequired: true,
    propName: 'id',
  },
  {
    title: <FormattedMessage {...messages.firstName} />,
    id: 'address_first_name',
    element: 'input',
    type: 'text',
    maxLength: 128,
    isRequired: true,
    propName: 'firstName',
  },
  {
    title: <FormattedMessage {...messages.lastName} />,
    id: 'address_last_name',
    element: 'input',
    type: 'text',
    maxLength: 128,
    isRequired: true,
    propName: 'lastName',
  },
  {
    title: <FormattedMessage {...messages.company} />,
    id: 'address_company',
    element: 'input',
    type: 'text',
    maxLength: 128,
    propName: 'company',
  },
  {
    title: <FormattedMessage {...messages.country} />,
    id: 'address_country_code',
    element: 'select',
    type: null,
    options: [],
    maxLength: 128,
    isRequired: true,
    propName: 'countryCode',
  },
  {
    title: <FormattedMessage {...messages.country} />,
    id: `address_region_code`,
    element: 'select',
    type: null,
    options: [],
    maxLength: 128,
    isRequired: true,
    propName: 'regionCode',
  },
  {
    title: <FormattedMessage {...messages.addressLineOne} />,
    id: 'address_street_1',
    element: 'input',
    type: 'text',
    maxLength: 35,
    isRequired: true,
    propName: 'street[0]',
  },
  {
    title: <FormattedMessage {...messages.addressLineTwo} />,
    id: 'address_street_2',
    element: 'input',
    type: 'text',
    maxLength: 35,
    propName: 'street[1]',
  },
  {
    title: <FormattedMessage {...messages.postalCode} />,
    id: 'address_zip',
    element: 'input',
    type: 'text',
    maxLength: 60,
    isRequired: true,
    propName: 'zip',
  },
  {
    title: <FormattedMessage {...messages.city} />,
    id: 'address_city',
    element: 'input',
    type: 'text',
    maxLength: 128,
    isRequired: true,
    propName: 'city',
  },
  {
    title: <FormattedMessage {...messages.phone} />,
    id: 'address_phone',
    element: 'input',
    type: 'tel',
    maxLength: 128,
    isRequired: true,
    propName: 'phone',
  },
]);

export default fields;
